import { GlobalUserSettings } from "../models/global-user-settings.model";
import * as GlobalUserSettingsActions from "../actions/global-user-settings.actions";

const initialState: GlobalUserSettings = {
  modalSettings: {
    isVisibleEteModal: false,
    showExcelAdvanceOptions: false,
    showClose: true,
  },
};

export function globalUserSettingsReducer(
  state: GlobalUserSettings = initialState,
  action: GlobalUserSettingsActions.Actions,
) {
  switch (action.type) {
    case GlobalUserSettingsActions.SET_GLOBAL_SETTINGS_MODAL_VISIBILITY:
      return {
        ...state,
        modalSettings: {
          ...state.modalSettings,
          isVisibleEteModal: action.payload,
        },
      };

    case GlobalUserSettingsActions.SET_GLOBAL_SETTINGS_MODAL_CLOSE_ICON_VISIBILITY:
      return {
        ...state,
        modalSettings: {
          ...state.modalSettings,
          showClose: action.payload,
        },
      };

    case GlobalUserSettingsActions.SET_GLOBAL_SETTINGS_MODAL_ADVANCED_OPTIONS_VISIBILITY:
      return {
        ...state,
        modalSettings: {
          ...state.modalSettings,
          showExcelAdvanceOptions: action.payload,
        },
      };

    default:
      return state;
  }
}
